module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('slide', {
    attrs: {
      "from": "bottom",
      "show": _vm.mergeShow,
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "beast-login-warp merge"
  }, [_c('div', {
    staticClass: "merge-main"
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": require("./assets/close.png")
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "rule",
    attrs: {
      "src": require("./assets/merge-rule.png")
    },
    on: {
      "click": _vm.rule
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-head"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/wtf.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("手机验证")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "merge-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.phone) + "已被以下账号作为登录手机号")]), _vm._v(" "), (_vm.mergeData.mergeable) ? _c('p', [_vm._v("请确认是否合并账号")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "merge-member"
  }, [_c('div', {
    staticClass: "header-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.headImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "member-content"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.member.profile.nickName || _vm.phone))]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('div', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.member.level.name))]), _vm._v(" "), _c('div', {
    staticClass: "tag"
  }, [_vm._v("积分" + _vm._s(_vm.member.point))])])])]), _vm._v(" "), (_vm.mergeData.mergeable) ? _c('div', {
    staticClass: "merge-tips"
  }, [_vm._v("\n            " + _vm._s(_vm.mergeData.attention) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "merge-btn-list"
  }, [(!_vm.mergeData.mergeable) ? _c('div', {
    staticClass: "login-btn bottom",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n            换个手机号验证\n          ")]) : _vm._e(), _vm._v(" "), (_vm.mergeData.mergeable) ? _c('div', {
    staticClass: "login-btn bottom",
    on: {
      "click": _vm.merge
    }
  }, [_vm._v("\n            是我的账号，确认合并\n          ")]) : _vm._e(), _vm._v(" "), (_vm.mergeData.mergeable) ? _c('div', {
    staticClass: "merge-not-btn bottom",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n            不是我的账号，换个手机号验证\n          ")]) : _vm._e()])])])]), _vm._v(" "), _c('merge-rule', {
    attrs: {
      "mergeRuleShow": _vm.mergeRuleShow
    },
    on: {
      "cancel": _vm.ruleClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ef991f8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/app-login/merge.vue
// module id = 118
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 14 15 16 17 18 20 21 22 23 25 26 29 30 31 32 34 35 36 38 41 42 43 45 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63